import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { primary } from "../../../constants/theme";
const CustomHeaderDesc = styled(Box)(({ theme }) => ({
  width: "84%",
  margin: "20px auto",
  ".content-container": {
    margin: "auto",
  },
  ".content-text": {
    fontSize: "16px",
    marginBottom: "10px",
    fontWeight: "400",
    color: primary.black,
  },
  ".content-heading2": {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "10px",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "0 12px",
    ".content-container": {
      ".content-text": {
        fontSize: "16px",
      },
      ".content-heading2": {
        fontSize: "24px",
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "0 12px",
    ".content-container": {
      width: "100%",
      padding: "0 12px",
      ".content-text": {
        fontSize: "12px",
      },
      ".content-heading2": {
        fontSize: "24px",
      },
    },
  },
}));
const HeaderDesc = ({ heading = "", subText = "", HeadingTag = "h4" }) => {
  return (
    <CustomHeaderDesc>
      <Box className="content-container">
        <Typography variant={HeadingTag} className="content-heading2">
          {heading}
        </Typography>
        <Typography
          variant="p"
          className="content-text"
          dangerouslySetInnerHTML={{ __html: subText }}
        ></Typography>
      </Box>
    </CustomHeaderDesc>
  );
};
export default HeaderDesc;
